export const toStyleText = (styles) => {
    const result = [];
    Object.keys(styles).forEach((k) => {
        const val = styles[k];
        if (!val) {
            return;
        }
        const key = k.replace(/([A-Z])/g, (it) => `-${it.toLowerCase()}`);
        result.push(`${key}:${val}`);
    });
    return result.join(';');
};
